import React from 'react'
import { V2NotificationpreferencesIcon } from '@paypalcorp/pp-react'

export const sharePermissionConstants = {
  Heading: 'Share Permission Requests',
  Title: 'Request Share Permission',
  TotalNoOfShareePerRequest: 10,
  InvalidEmailId: 'Enter valid mail id',
  Only10EmailIdsAllowedErrorMsg: 'Cannot add more than 10 email IDs.',
  RequestIdFormat: /(?:^|\/)([A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{8}-[A-F0-9]{4}-[A-F0-9]{12})(?:\/)?$/i,
  fields: {
    share_recipient: {
      title: 'Share with ',
      label: 'Email ID',
      key: 'share_recipient',
      placeholder: 'Enter Email ID',
      className:
        'share__permission-input-box share__permission-recipient-content_box',
      isLabelHidden: true,
      isMandatory: true,
      type: 'email',
      note: `Add multiple email ID's separated by semicolon (;)`,
    },
    business_justification: {
      title: 'Business Justification ',
      label: 'Justification',
      key: 'business_justification',
      placeholder: 'Enter Business Justification',
      className:
        'share__permission-content-box text-area share__permission-justification-content_box',
      maxCharacters: 1000,
      minCharacters: 50,
      isMandatory: true,
      htmlTagsNotAllowed:
        'HTML tags or scripts not allowed. Please remove it and try again.',
      linkNotAllowedAlert:
        'Link not allowed. Please remove the link and try again.',
    },
    data_source: {
      title: 'Data Source ',
      label: 'Data Source',
      key: 'data_source',
      placeholder: 'Enter Data Source',
      className:
        'share__permission-content-box text-area share__permission-justification-content_box',
      maxCharacters: 1000,
      minCharacters: 50,
      isMandatory: true,
      htmlTagsNotAllowed:
        'HTML tags or scripts not allowed. Please remove it and try again.',
      linkNotAllowedAlert:
        'Link not allowed. Please remove the link and try again.',
    },
    duration: {
      title: 'Duration in days ',
      label: 'Duration in days',
      key: 'duration_in_days',
      placeholder: 'Enter Duration in days',
      className:
        'share__permission-input-box share__permission-recipient-content_box',
      maxLength: 3,
      isLabelHidden: true,
      isMandatory: true,
      type: 'number',
      note: {
        info: 'Maximum duration for share access is 365 days.',
      },
      invalidDuration: 'Please enter a valid number between 1 and 365.',
      durationExceed: 'Duration cannot exceed 365 days.',
    },
    data_classification: {
      title: 'Data Classification ',
      label: 'Data Classification',
      key: 'data_classification',
      placeholder: 'Select Data Classification',
      className: 'dropdown-menu',
      options: [
        {
          labelKey: 'Class 2 - PCI Related',
          value: 'CLASS_2A',
          key: 'CLASS_2A',
        },
        {
          labelKey: 'Class 2 - Non-PCI',
          value: 'CLASS_2B',
          key: 'CLASS_2B',
        },
        {
          labelKey: 'Class 3 - Customer PII',
          value: 'CLASS_3A',
          key: 'CLASS_3A',
        },
        {
          labelKey: 'Class 3 - Other',
          value: 'CLASS_3B',
          key: 'CLASS_3B',
        },
        {
          labelKey: 'Class 4',
          value: 'CLASS_4',
          key: 'CLASS_4',
        },
        {
          labelKey: 'Class 5',
          value: 'CLASS_5',
          key: 'CLASS_5',
        },
      ],
      isMandatory: true,
      note: {
        info: 'To know more about Data Classification, visit ',
        linkText: 'Data Classification Info',
        link: 'https://go/dataclassifications',
      },
    },
    org_details: {
      title: 'Organization Details ',
      label: 'Organization Details',
      key: 'org_details',
      placeholder: 'Select Organization Details',
      className: 'dropdown-menu',
      options: [
        {
          labelKey: 'Consumer',
          value: 'Consumer',
          key: 'consumer',
        },
        {
          labelKey:
            'Corporate Services (CS, Marketing, HR, Legal, ETX, Finance)',
          value: 'Corporate Services',
          key: 'corporate_service',
        },
        {
          labelKey: 'Merchant',
          value: 'Merchant',
          key: 'merchant',
        },
        {
          labelKey: 'Identity, Risk, Fraud',
          value: 'Identity Risk Fraud',
          key: 'identity_risk_fraud',
        },
        {
          labelKey: 'Product Common Services (Payments, DIAS, SRE, DPE)',
          value: 'Product Common Services',
          key: 'product_common_services',
        },
      ],
      isMandatory: true,
    },
    comment: {
      title: 'Comment : ',
      label: 'Comment',
      key: 'comment',
      placeholder: 'Enter Comment',
      className:
        'share__permission-content-box text-area share__permission-comment-content_box',
      maxCharacters: 1000,
      minCharacters: 15,
      isMandatory: true,
      htmlTagsNotAllowed:
        'HTML tags or scripts not allowed. Please remove it and try again.',
      linkNotAllowedAlert:
        'Link not allowed. Please remove the link and try again.',
    },
  },
  statusMsg: {
    requestActionSuccess:
      'Request has been {operation} successfully. Please connect with {approver} to move it forward for approval.',
    requestActionCancelled:
      'Your request has been cancelled. No further action is required.',
    requestActionGeneral: 'Request has been {operation} successfully.',
    requestActionResumed:
      'The request has been resumed successfully. File and folder sharing is now enabled.',
    requestActionResumeRejected: 'The request has been rejected by InfoSec.',
    requestActionError: 'Error while {operation} share permission request',
    noChangesDetected:
      'No changes detected. Please edit the required field and try again.',
    requestProcessing: 'Please wait while {operation} the request...',
    requestActionWarning: 'Are you sure you want to {operation} the request?',
  },
  requestDetailsLabels: {
    title: 'Share Permission Request Details',
    request_id: 'Request ID',
    approver: 'Approver',
    status: 'Status',
    sharee_email_addresses: 'Requested For',
    business_justification: 'Business Justification',
    data_source: 'Source of Data',
    data_classification: 'Data Classification',
    duration_in_days: 'Duration',
    expire_on: 'Expiry on',
    dayText: 'Day',
    daysText: 'Days',
    infosec_domain: 'Organization Details',
    infosec_ticket: 'InfoSec Ticket',
    approver_comment: 'Approver Comments',
    approver_action_at: 'Approver Action At',
    infosec_action_at: 'InfoSec Action At',
    created_at: 'Created At',
    last_updated_at: 'Last Updated At',
  },
  requiredDetailsToViewRequest: [
    'request_id',
    'requestor',
    'sharee_email_addresses',
    'business_justification',
    'data_classification',
    'duration_in_days',
    'approver',
    'approver_comment',
    'approver_action_at',
    'infosec_ticket',
    'infosec_action_at',
    'status',
    'created_at',
    'last_updated_at',
    'infosec_domain',
  ],
  requestedDetailsActions: [
    /**
     * className, isSecondary, isDisabled, renderFor is required for create and update form
     * title, key is required for create and update form
     * label, value is required for list page
     * visibleForTab, visibleForStatus is required for list page
     * visibleFor is required for view individual request page
     * isVisible is required for all pages
     */
    {
      title: 'Cancel',
      label: 'Cancel',
      value: 'cancel',
      key: 'cancel',
      className: 'ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter',
      isSecondary: true,
      isDisabled: false,
      isVisible: true,
      renderFor: ['create', 'update', 'withdraw'],
      visibleForTab: [],
      visibleForStatus: [],
      visibleFor: [],
    },
    {
      title: 'Submit',
      label: 'Submit',
      value: 'submit',
      key: 'submit',
      className: 'ppvx_btn ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      isVisible: true,
      renderFor: ['create'],
      visibleForTab: [],
      visibleForStatus: [],
      visibleFor: [],
    },
    {
      title: 'View',
      label: 'View',
      value: 'view',
      key: 'view',
      visibleForTab: ['approvals', 'my_requests', 'completed_requests'],
      visibleForStatus: [
        'PENDING_APPROVAL',
        'PENDING_INFOSEC_APPROVAL',
        'APPROVED',
        'REJECTED',
        'CANCELLED',
      ],
      isVisible: true,
      className: 'ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      visibleFor: [],
      renderFor: [],
    },
    {
      title: 'Close',
      label: 'Close',
      value: 'close',
      key: 'close',
      className: 'ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      isVisible: true,
      visibleFor: ['requestor', 'approver'],
      visibleForTab: [],
      visibleForStatus: [],
      renderFor: [],
    },
    {
      title: 'Update',
      label: 'Update',
      value: 'update',
      key: 'update',
      className: 'ppvx_btn ppvx_btn--size_md flexCenter',
      isSecondary: true,
      isDisabled: false,
      isVisible: true,
      visibleFor: ['requestor'],
      visibleForTab: ['my_requests'],
      visibleForStatus: ['PENDING_APPROVAL'],
      renderFor: ['update'],
    },
    {
      title: 'Withdraw',
      label: 'Withdraw',
      value: 'withdraw',
      key: 'withdraw',
      className: 'ppvx_btn ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      isVisible: true,
      visibleFor: ['requestor'],
      visibleForTab: ['my_requests'],
      visibleForStatus: ['PENDING_APPROVAL'],
      renderFor: [],
    },
    {
      title: 'Approve',
      label: 'Approve',
      value: 'approve',
      key: 'approve',
      className: 'ppvx_btn ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      isVisible: true,
      visibleFor: ['approver'],
      visibleForTab: ['approvals'],
      visibleForStatus: ['PENDING_APPROVAL'],
      renderFor: [],
    },
    {
      title: 'Reject',
      label: 'Reject',
      value: 'reject',
      key: 'reject',
      className: 'ppvx_btn ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      isVisible: true,
      visibleFor: ['approver'],
      visibleForTab: ['approvals'],
      visibleForStatus: ['PENDING_APPROVAL'],
      renderFor: [],
    },
    {
      title: 'Resume',
      label: 'Resume',
      value: 'resume',
      key: 'resume',
      className: 'ppvx_btn ppvx_btn--size_md flexCenter',
      isSecondary: false,
      isDisabled: false,
      isVisible: true,
      visibleFor: ['requestor'],
      visibleForTab: ['my_requests'],
      visibleForStatus: ['PENDING_INFOSEC_APPROVAL'],
      renderFor: [],
    },
  ],
  permissionRequestList: {
    headerIcon: {
      title: 'Share Permission Request',
      icon: <V2NotificationpreferencesIcon size="md" />,
    },
    requestAccess: {
      label: 'Request Access',
    },
    requestPerPage: 10,
    pageSize: 1000,
    isTotalRequired: true,
    tabDetails: {
      name: 'Share Access tab',
      key: 'share_access_tab',
      tabs: [
        {
          label: 'My Request',
          id: 'my_requests',
          panelId: 'my_requests_panel',
        },
        { label: 'Approvals', id: 'approvals', panelId: 'approvals_panel' },
        {
          label: 'Completed Request',
          id: 'completed_requests',
          panelId: 'completed_requests_panel',
        },
      ],
    },
    tableHeader: {
      id: {
        label: 'ID',
        key: 'request_id',
        className:
          'permission__request-list-items permission__request-list-request_id dFlexCenter',
        renderFor: [],
      },
      requestor: {
        label: 'Requestor',
        key: 'requestor',
        className:
          'permission__request-list-items permission__request-list-requestor dFlexAlignCenter',
        renderFor: ['approvals', 'completed_requests'],
      },
      sharee_email_addresses: {
        label: `Sharee Email ID's`,
        key: 'sharee_email_addresses',
        className:
          'permission__request-list-items permission__request-list-sharee_email_addresses dFlexAlignCenter',
        renderFor: ['approvals', 'my_requests', 'completed_requests'],
      },
      business_justification: {
        label: 'Business Justification',
        key: 'business_justification',
        className:
          'permission__request-list-items permission__request-list-business_justification dFlexAlignCenter',
        renderFor: ['approvals'],
      },
      data_classification: {
        label: 'Data Classification',
        key: 'data_classification',
        className:
          'permission__request-list-items permission__request-list-business_justification dFlexCenter',
        renderFor: ['approvals', 'my_requests', 'completed_requests'],
      },
      duration_in_days: {
        label: 'Duration',
        key: 'duration_in_days',
        className:
          'permission__request-list-items permission__request-list-duration_in_days dFlexCenter',
        renderFor: ['approvals', 'my_requests', 'completed_requests'],
      },
      infosec_domain: {
        label: 'Infosec Domain',
        key: 'infosec_domain',
        className:
          'permission__request-list-items permission__request-list-infosec_domain dFlexCenter',
        renderFor: [],
      },
      infosec_ticket: {
        label: 'Infosec Ticket',
        key: 'infosec_ticket',
        className:
          'permission__request-list-items permission__request-list-infosec_ticket dFlexCenter',
        renderFor: ['my_requests', 'completed_requests'],
      },
      approver: {
        label: 'Approver',
        key: 'approver',
        className:
          'permission__request-list-items permission__request-list-approver dFlexCenter',
        renderFor: ['my_requests', 'completed_requests'],
      },
      last_updated_at: {
        label: 'Updated At',
        key: 'last_updated_at',
        className:
          'permission__request-list-items permission__request-list-created_at dFlexCenter',
        renderFor: ['approvals', 'my_requests', 'completed_requests'],
      },
      status: {
        label: 'Status',
        key: 'status',
        className:
          'permission__request-list-items permission__request-list-status dFlexCenter',
        renderFor: ['approvals', 'my_requests', 'completed_requests'],
      },
      action: {
        label: 'Action',
        key: 'action',
        className:
          'permission__request-list-items permission__request-list-action dFlexCenter',
        renderFor: ['approvals', 'my_requests', 'completed_requests'],
      },
    },
    statusPerTab: {
      approvals: ['PENDING_APPROVAL'],
      my_requests: ['PENDING_APPROVAL', 'PENDING_INFOSEC_APPROVAL'],
      completed_requests: ['APPROVED', 'REJECTED', 'CANCELLED'],
    },
    searchOptions: [
      { labelKey: 'Request ID', value: 'request_id' },
      { labelKey: 'Requestor', value: 'requestor' },
      { labelKey: 'Approver', value: 'approver' },
      { labelKey: 'Sharee Email IDs', value: 'sharee_email_addresses' },
      { labelKey: 'Business Justification', value: 'business_justification' },
      { labelKey: 'Data Source', value: 'data_source' },
      { labelKey: 'Organisation', value: 'infosec_domain' },
      { labelKey: 'Infosec Ticket', value: 'infosec_ticket' },
    ],
    filterOptions: {
      status: [
        {
          labelKey: 'All',
          value: 'all',
          renderFor: ['my_requests', 'completed_requests'],
        },
        {
          labelKey: 'Pending Approval',
          value: 'PENDING_APPROVAL',
          renderFor: ['my_requests'],
        },
        {
          labelKey: 'Pending InfoSec Approval',
          value: 'PENDING_INFOSEC_APPROVAL',
          renderFor: ['my_requests'],
        },
        {
          labelKey: 'Approved',
          value: 'APPROVED',
          renderFor: ['completed_requests'],
        },
        {
          labelKey: 'Rejected',
          value: 'REJECTED',
          renderFor: ['completed_requests'],
        },
        {
          labelKey: 'Cancelled',
          value: 'CANCELLED',
          renderFor: ['completed_requests'],
        },
      ],
      dateFilter: {
        startDate: {
          labelKey: 'Start Date',
          value: 'start_date',
        },
        endDate: {
          labelKey: 'End Date',
          value: 'end_date',
        },
        minDate: new Date().setFullYear(
          new Date().getFullYear() - 1,
        ) /* min date for date picker */,
      },
    },
    labels: {
      showingResults: 'Showing',
      ofResults: 'of',
      requestsText: 'requests',
      fromDate: 'From Date',
      toDate: 'To Date',
      dateRange: 'Date Range',
      dateSeparator: 'to',
      resultsTemplate: 'Showing {filtered} of {total} requests',
    },
  },
  permissionStatusLabel: {
    PENDING_APPROVAL: 'PENDING APPROVAL',
    PENDING_INFOSEC_APPROVAL: 'PENDING INFOSEC APPROVAL',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
  },
  RitmLink: {
    prod:
      'https://paypal.service-now.com/nav_to.do?uri=sc_req_item.do?sysparm_query=number={ritmID}',
    qa:
      'https://paypaltest.service-now.com/nav_to.do?uri=sc_req_item.do?sysparm_query=number={ritmID}',
  },
}
